export enum MessageToLureAction {
  CLOSE = 'close',
  UNPAIR_SECTION = 'unpairSection',
  GRADE_RESYNC = 'gradeResync',
  RESYNC = 'resync',
}
